// extracted by mini-css-extract-plugin
module.exports = {"transactionListContainer":"OfferHistory_transactionListContainer__k__dF","table":"OfferHistory_table__RE998","warning":"OfferHistory_warning__SK6WJ"};